import { PROJECT_OVERVIEW_TABLE } from '@rd-web-markets/market/dist/constants'

export const createProjectOverviewHeaders = (customHeaders, claimGroup, groupProjects, t, shouldRemoveSubsidiaryName) => {
  let headers = customHeaders ? [...customHeaders] : [...PROJECT_OVERVIEW_TABLE.headers]

  if (!!claimGroup?.reports_start_years?.length) {
    const withAddedDynamicYearsForYearSelect = headers.map(h => {
      if (h.orderBy == 'rd_start_year') {
        return {
          ...h,
          filterOptions: claimGroup.reports_start_years
        }
      } else {
        return h
      }
    })

    headers = [...withAddedDynamicYearsForYearSelect]
  }

  if (groupProjects === 'program' || groupProjects === true) {
    headers.push({ text: t('view_projects') })
  }


  if (shouldRemoveSubsidiaryName) {
    return headers.filter(h => h.text !== 'subsidiary_company_name')
      .map(h => {
        return { ...h, text: t(h.text) }
      })
  }

  return headers.map(h => {
    return { ...h, text: t(h.text) }
  })
}
